import { useState } from 'react'
import { useMethods } from '@shared/hooks/methods'
import { useEasyProvider } from '@shared/components/EasyProvider'
import { useRestFetch } from '@shared/hooks/rest/fetch'
import { useRestMutation } from '@shared/hooks/rest/mutate'

import axios from '@shared/utils/axios'

export const useList = () => {
    const [anchor, setAnchor] = useState(null)
    
    // crud
    const {
        ask,
        showMessage
    } = useMethods()
    const {
        instance,
        setInstance,
        setFormVisibility
    } = useEasyProvider()
    const query = useRestFetch({key: ['pdc-delegates'], endpoint: 'settings/pdc-delegates/'})
    const { mutate } = useRestMutation({
        invalidate: [['pdc-delegates']],
        process: async () => (await axios.delete(`settings/pdc-delegates/${instance.id}/`)).data,
    })

    const handleDelete = () => {
        setAnchor(null)
        ask(
            `هل تريد حذف الممثل '${instance.name}'`,
            mutate
        )
    }

    const handleFetchInstance = async () => {
        showMessage({ text: 'جارٍ التحميل...', loading: true })
        try {
            const request = await axios.get(`settings/pdc-delegates/${instance.id}/`)
            setAnchor(false)
            setInstance(request.data)
            setFormVisibility(true)
            showMessage(null)
        } catch {
            showMessage({ text: 'حدث خطأ اثناء جلب الممثل.' })
        }
    }

    return {
        query,

        anchor,
        setAnchor,
        setInstance,

        handleDelete,
        handleFetchInstance,
    }
}